import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { InventoryService } from 'src/app/business-service/inventory/inventory.service';
import { ItineraryService } from 'src/app/business-service/quote/itinerary.service';
import { ReviewItineraryComponent } from '../review-itinerary/review-itinerary.component';
import { ResponseNotificationService } from '../../shared/services/response-notification/response-notification.service';
import { ItineraryDetailsComponent } from './itinerary-details/itinerary-details.component';
import { AccomodationComponent } from './accomodation/accomodation.component';
import { TransportationComponent } from './transportation/transportation.component';
import { RouteCraftComponent } from './route-craft/route-craft.component';
import { CostAndPriceComponent } from './cost-and-price/cost-and-price.component';
import { InclusionsAndExclusionsComponent } from './inclusions-and-exclusions/inclusions-and-exclusions.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { CancellationPolicyComponent } from './cancellation-policy/cancellation-policy.component';
import { ImportantInformationComponent } from './important-information/important-information.component';
import { NotesComponent } from './notes/notes.component';
import { TemplatesComponent } from './templates/templates.component';
import { LeadsService } from 'src/app/business-service/leads/leads.service';
import { GlobalService } from '../../shared/services/global/global.service';
import { ENTITY_NAMES, RECORD_STATUS_VALUES } from '../../shared/constants/api-constants';
import { TemplateDataComponent } from './template-data/template-data.component';
import { ComponentReloadService } from '../../shared/services/reload/component-reload.service';
import { PaymentTermsAndConditionsComponent } from './payment-terms-and-conditions/payment-terms-and-conditions.component';
import { ModalsService } from '../../shared/services/modals/modals.service';
import { CombinedTermsComponent } from './combined-terms/combined-terms.component';
import { forkJoin, tap } from 'rxjs';
import { LeadInformationComponent } from './lead-information/lead-information.component';
import { StatusUpdateService } from 'src/app/business-service/status-update/status-update.service';
import { DmcPackageService } from 'src/app/business-service/dmc-package/dmc-package.service';
import { Resolve } from '@angular/router';
import { DmcPackageQuoteComponent } from './dmc-package-quote/dmc-package-quote.component';
import { ItineraryHelperService } from '../helpers/itinerary-helper-service';

@Component({
  selector: 'app-itinerary-form',
  templateUrl: './itinerary-form.component.html',
  styleUrls: ['./itinerary-form.component.scss'],
})
export class ItineraryFormComponent implements OnInit {

  @ViewChild(LeadInformationComponent) leadInformationComponent!: LeadInformationComponent
  @ViewChild(ItineraryDetailsComponent) itineraryDetailsComponent!: ItineraryDetailsComponent;
  @ViewChild(AccomodationComponent) accomodationComponent!: AccomodationComponent;
  @ViewChild(TransportationComponent) transportationComponent!: TransportationComponent;
  @ViewChild(RouteCraftComponent) routeCraftComponent!: RouteCraftComponent;
  @ViewChild(DmcPackageQuoteComponent) dmcPackageComponent!: DmcPackageQuoteComponent;
  @ViewChild(CostAndPriceComponent) costAndPriceComponent!: CostAndPriceComponent;
  @ViewChild(InclusionsAndExclusionsComponent) inclusionsAndExclusionsComponent!: InclusionsAndExclusionsComponent;
  @ViewChild(TermsAndConditionsComponent) termsAndConditionsComponent!: TermsAndConditionsComponent;
  @ViewChild(PaymentTermsAndConditionsComponent) paymentTermsAndConditionsComponent!: PaymentTermsAndConditionsComponent;
  @ViewChild(CancellationPolicyComponent) cancellationPolicyComponent!: CancellationPolicyComponent;
  @ViewChild(ImportantInformationComponent) importantInformationComponent!: ImportantInformationComponent;
  @ViewChild(NotesComponent) notesComponent!: NotesComponent;
  @ViewChild(TemplatesComponent) templatesComponent!: TemplatesComponent;
  @ViewChild(TemplateDataComponent) templateDetailsComponent!: TemplateDataComponent;
  @ViewChild(CombinedTermsComponent) combinedTermsComponent!: CombinedTermsComponent;


  leadId: any;
  leadDetails: any;
  itineraryId: any;
  leadTravelServices: any;
  teamplateId: any;
  dmcPackageId: any;
  destinationsReordered: boolean = false;
  targetTab: any;

  serviceBasedSections: any = {
    showHotels: true,
    showRouteCraft: true,
    showTransportation: true,
    showTransfers: true,
    showTourPackage: true
  }

  editInventoryItineraray: any;
  editQuoteItinerary: any;
  parentItineraryId: any = null;

  // Clone id used to clone quote for a new lead
  cloneItineraryId: any;

  // All itinearay or quote data
  inventoryItineraryData: any;
  quoteItineraryData: any;

  // Form data of each tab in add itinerary
  // used to patch data when user gets back to filled tab after submittion
  detailsFormData: any;
  accommodationFormData: any;
  dmcHotelPricingFormData: any;
  // Transporation form data
  transportationFormData: any;
  flightsTransportationFormData: any;
  flightsEditedFormData: any;
  trainTransportationFormData: any;
  busTransportationFormData: any;
  carTransportationFormData: any;
  ferryTransportationFormData: any;
  cruiseTransportationFormData: any;

  routeCraftFormData: any;
  inclusionsAndExclusionsFormData: any;
  costAndPricingFormData: any;
  termsAndConditionsFormData: any;
  paymentTermsAndConditionsFormData: any;
  cancellationPolicyFormData: any;
  importantInformationFormData: any;
  notesFormData: any;
  templatesFormData: any;
  templatesDetailsFormData: any;

  quoteStatus: any;
  RECORD_STATUS_VALUES = RECORD_STATUS_VALUES;

  orderOfTabs: string[] = ['lead', 'details', 'route', 'accommodation', 'transportation', 'cost', 'inclusion', 'combined-terms', 'important', 'notes', 'templates', 'templates-details', 'review'];
  orderOfTabsIndex: number = 1;
  componentView: string = this.orderOfTabs[this.orderOfTabsIndex];

  constructor(
    private _modalController: ModalController,
    private _inventoryService: InventoryService,
    private _itineraryService: ItineraryService,
    private _responseNotificationService: ResponseNotificationService,
    private _leadService: LeadsService,
    private _globalService: GlobalService,
    private _reloadService: ComponentReloadService,
    private _modalPopupService: ModalsService,
    private _statusUpdateService: StatusUpdateService,
    private _itineraryHelperService: ItineraryHelperService
  ) { }

  async ngOnInit() {
    // getting all default values from helper service
    const defaultValues = this._itineraryHelperService.getItineraryFormDefaultValues();
    this.leadId = defaultValues?.leadId || null;
    this.editInventoryItineraray = defaultValues?.editInventoryItineraray || null;
    this.editQuoteItinerary = defaultValues?.editQuoteItinerary || null;
    this.cloneItineraryId = defaultValues?.cloneItineraryId || null;
    this.targetTab = defaultValues?.targetTab || null;

    if (this.leadId) {
      await this.getLeadServices();
    } else if (this.cloneItineraryId) {
      // Dummy value used for lead id, so that existing constions based on lead id should work properly
      this.leadId = this.cloneItineraryId
      this.orderOfTabsIndex = 0;
      this.componentView = this.orderOfTabs[this.orderOfTabsIndex];
    } else {
      this.updateListOfTabsForInventory();
    }
    if (this.editInventoryItineraray) {
      this.itineraryId = this.editInventoryItineraray
      this._inventoryService.getInventoryItinerary(this.editInventoryItineraray).subscribe((data) => {
        this.inventoryItineraryData = data;
        this.assignInventoryItineraryDetails();
      })
    }

    if (this.editQuoteItinerary) {
      this.itineraryId = this.editQuoteItinerary
      this._itineraryService.getQuoteData(this.editQuoteItinerary).subscribe((data) => {
        this.quoteItineraryData = data;

        this.assignItineraryQuoteDetails();
      })

    }

    if(this.targetTab){
      this.changeComponentView(this.targetTab);
    }
  }

  assignItineraryQuoteDetails() {
    // assigning parent ID and status
    this.parentItineraryId = this.quoteItineraryData.itineraryDetails?.parentItineraryId || null;
    this.quoteStatus = this.quoteItineraryData.itineraryDetails?.status || null;
    this.dmcPackageId = this.quoteItineraryData.itineraryDetails?.packageId || null;
    if (this.dmcPackageId) {
      this.updateListOfTabsForDmcPackage();
    }

    this.detailsFormData = this.quoteItineraryData.itineraryDetails
      ? { ...this.detailsFormData, ...this.quoteItineraryData.itineraryDetails }
      : null;

    this.accommodationFormData = this.quoteItineraryData.accommodations
      ? { ...this.accommodationFormData, ...this.quoteItineraryData.accommodations }
      : null;

    this.flightsTransportationFormData = this.quoteItineraryData.flights
      ? { ...this.flightsTransportationFormData, ...this.quoteItineraryData.flights }
      : null;

    this.trainTransportationFormData = this.quoteItineraryData.trains
      ? { ...this.trainTransportationFormData, ...this.quoteItineraryData.trains }
      : null;

    this.busTransportationFormData = this.quoteItineraryData.buses
      ? { ...this.busTransportationFormData, ...this.quoteItineraryData.buses }
      : null;

    this.carTransportationFormData = this.quoteItineraryData.cars
      ? { ...this.carTransportationFormData, ...this.quoteItineraryData.cars }
      : null;

    this.ferryTransportationFormData = this.quoteItineraryData.ferries
      ? { ...this.ferryTransportationFormData, ...this.quoteItineraryData.ferries }
      : null;

    this.cruiseTransportationFormData = this.quoteItineraryData.cruises
      ? { ...this.cruiseTransportationFormData, ...this.quoteItineraryData.cruises }
      : null;

    this.routeCraftFormData = this.quoteItineraryData.routeCrafts
      ? { ...this.routeCraftFormData, ...this.quoteItineraryData.routeCrafts }
      : null;

    this.inclusionsAndExclusionsFormData = this.quoteItineraryData.inclusionAndExclusions
      ? { ...this.inclusionsAndExclusionsFormData, ...this.quoteItineraryData.inclusionAndExclusions }
      : null;

    this.costAndPricingFormData = this.quoteItineraryData.costAndPricings
      ? { ...this.costAndPricingFormData, ...this.quoteItineraryData.costAndPricings }
      : null;

    this.dmcHotelPricingFormData = this.quoteItineraryData.hotelPricingCollection
      ? { ...this.dmcHotelPricingFormData, ...this.quoteItineraryData.hotelPricingCollection }
      : null;

    this.termsAndConditionsFormData = this.quoteItineraryData.termsAndConditions
      ? { ...this.termsAndConditionsFormData, ...this.quoteItineraryData.termsAndConditions }
      : null;

    this.paymentTermsAndConditionsFormData = this.quoteItineraryData.paymentTermsAndConditions
      ? { ...this.paymentTermsAndConditionsFormData, ...this.quoteItineraryData.paymentTermsAndConditions }
      : null;

    this.cancellationPolicyFormData = this.quoteItineraryData.cancellationPolicies
      ? { ...this.cancellationPolicyFormData, ...this.quoteItineraryData.cancellationPolicies }
      : null;

    this.importantInformationFormData = this.quoteItineraryData.importantInformations
      ? { ...this.importantInformationFormData, ...this.quoteItineraryData.importantInformations }
      : null;

    this.notesFormData = this.quoteItineraryData.notes
      ? { ...this.notesFormData, ...this.quoteItineraryData.notes }
      : null;

    this.templatesDetailsFormData = this.quoteItineraryData.template
      ? { ...this.templatesDetailsFormData, ...this.quoteItineraryData.template }
      : null;

    this.templatesFormData = this.quoteItineraryData.template
      ? { ...this.templatesFormData, ...this.quoteItineraryData.template }
      : null;

    this.makeAvalibleTabsGreen();
  }



  assignInventoryItineraryDetails() {
    this.detailsFormData = this.inventoryItineraryData.itineraryDetails
      ? { ...this.detailsFormData, ...this.inventoryItineraryData.itineraryDetails }
      : null;

    this.routeCraftFormData = this.inventoryItineraryData.routeCrafts
      ? { ...this.routeCraftFormData, ...this.inventoryItineraryData.routeCrafts }
      : null;

    this.inclusionsAndExclusionsFormData = this.inventoryItineraryData.inclusionAndExclusions
      ? { ...this.inclusionsAndExclusionsFormData, ...this.inventoryItineraryData.inclusionAndExclusions }
      : null;

    this.termsAndConditionsFormData = this.inventoryItineraryData.termsAndConditions
      ? { ...this.termsAndConditionsFormData, ...this.inventoryItineraryData.termsAndConditions }
      : null;

    this.cancellationPolicyFormData = this.inventoryItineraryData.cancellationPolicies
      ? { ...this.cancellationPolicyFormData, ...this.inventoryItineraryData.cancellationPolicies }
      : null;

    this.importantInformationFormData = this.inventoryItineraryData.importantInformations
      ? { ...this.importantInformationFormData, ...this.inventoryItineraryData.importantInformations }
      : null;

    this.notesFormData = this.inventoryItineraryData.notes
      ? { ...this.notesFormData, ...this.inventoryItineraryData.notes }
      : null;

    this.makeAvalibleTabsGreen();
  }



  makeAvalibleTabsGreen() {
    if (this.detailsFormData) {
      this.detailsFormData.dataSaved = true;
    }
    if (this.accommodationFormData) {
      this.accommodationFormData.dataSaved = true;
    }
    if (this.transportationFormData) {
      this.transportationFormData.dataSaved = true;
    }
    if (this.flightsTransportationFormData) {
      this.flightsTransportationFormData.dataSaved = true;
    }
    if (this.trainTransportationFormData) {
      this.trainTransportationFormData.dataSaved = true;
    }
    if (this.busTransportationFormData) {
      this.busTransportationFormData.dataSaved = true;
    }
    if (this.carTransportationFormData) {
      this.carTransportationFormData.dataSaved = true;
    }
    if (this.ferryTransportationFormData) {
      this.ferryTransportationFormData.dataSaved = true;
    }
    if (this.cruiseTransportationFormData) {
      this.cruiseTransportationFormData.dataSaved = true;
    }
    if (this.routeCraftFormData) {
      this.routeCraftFormData.dataSaved = true;
    }
    if (this.inclusionsAndExclusionsFormData) {
      this.inclusionsAndExclusionsFormData.dataSaved = true;
    }
    if (this.costAndPricingFormData) {
      this.costAndPricingFormData.dataSaved = true;
    }
    if (this.dmcHotelPricingFormData) {
      this.dmcHotelPricingFormData.dataSaved = true;
    }
    if (this.termsAndConditionsFormData) {
      this.termsAndConditionsFormData.dataSaved = true;
    }
    if (this.paymentTermsAndConditionsFormData) {
      this.paymentTermsAndConditionsFormData.dataSaved = true;
    }
    if (this.cancellationPolicyFormData) {
      this.cancellationPolicyFormData.dataSaved = true;
    }
    if (this.importantInformationFormData) {
      this.importantInformationFormData.dataSaved = true;
    }
    if (this.notesFormData) {
      this.notesFormData.dataSaved = true;
    }
    if (this.templatesFormData) {
      this.templatesFormData.dataSaved = true;
    }
    if (this.templatesDetailsFormData) {
      this.templatesDetailsFormData.dataSaved = true;
    }
  }

  // Function realated to cloning quote
  // Assigning new lead and new quote
  async assignNewLead(lead: any) {
    this.leadId = lead.leadId;
    this._itineraryService.cloneQuoteForNewLead(this.leadId, this.cloneItineraryId).subscribe({
      next: async (data) => {
        this._responseNotificationService.showMessage("Quote Cloning Successful")
        await this._modalPopupService.closeAllModals();
        await this._modalPopupService.openItineraryForm(lead.clientId, lead.leadId, data.quote, null, null, null);
      },
      error: (err) => {
        console.error('An error occurred while cloning quote for new lead', err);
      }
    })
  }

  ///////////////////

  reloadAllChildComponents() {
    if (this.itineraryDetailsComponent) {
      this.itineraryDetailsComponent.ngOnInit();
    }
    if (this.accomodationComponent) {
      this.accomodationComponent.ngOnInit();
    }
    if (this.transportationComponent) {
      this.transportationComponent.ngOnInit();
    }
    if (this.routeCraftComponent) {
      this.routeCraftComponent.ngOnInit();
    }
    if (this.costAndPriceComponent) {
      this.costAndPriceComponent.ngOnInit();
    }
    if (this.dmcPackageComponent) {
      this.dmcPackageComponent.ngOnInit();
    }
    if (this.inclusionsAndExclusionsComponent) {
      this.inclusionsAndExclusionsComponent.ngOnInit();
    }
    if (this.termsAndConditionsComponent) {
      this.termsAndConditionsComponent.ngOnInit();
    }
    if (this.paymentTermsAndConditionsComponent) {
      this.paymentTermsAndConditionsComponent.ngOnInit();
    }
    if (this.cancellationPolicyComponent) {
      this.cancellationPolicyComponent.ngOnInit();
    }
    if (this.importantInformationComponent) {
      this.importantInformationComponent.ngOnInit();
    }
    if (this.notesComponent) {
      this.notesComponent.ngOnInit();
    }
    if (this.templatesComponent) {
      this.templatesComponent.ngOnInit();
    }
    if (this.templateDetailsComponent) {
      this.templateDetailsComponent.ngOnInit();
    }
  }


  async getLeadServices(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this._leadService.getLead(this.leadId).subscribe({
        next: (data) => {
          this.leadDetails = data;
          this.leadDetails.dataSaved = true;
          this.leadTravelServices = data.travelServices;
          // Update tabs based on leads travel services
          this.serviceBasedSections.showHotels = this.leadTravelServices.includes('Hotels') ? true : false;
          this.serviceBasedSections.showRouteCraft = this.leadTravelServices.includes('Sightseeing') ? true : false;
          this.serviceBasedSections.showTransportation = this.leadTravelServices.includes("Transportations") ? true : false;
          this.serviceBasedSections.showTransfers = this.leadTravelServices.includes("Transfers") ? true : false;
          this.serviceBasedSections.showTourPackage = this.leadTravelServices.includes("Tour Package") ? true : false;

          this.updateListOfTabsForQuote(this.serviceBasedSections);
          this.reloadAllChildComponents();
          resolve();
        },
        error: (err) => {
          reject();
        }
      })
    })
    // this._leadService.getLead(this.leadId).subscribe((data) => {
    //   this.leadDetails = data;
    //   this.leadDetails.dataSaved = true;
    //   this.leadTravelServices = data.travelServices;
    //   // Update tabs based on leads travel services
    //   this.serviceBasedSections.showHotels = this.leadTravelServices.includes('Hotels') ? true : false;
    //   this.serviceBasedSections.showRouteCraft = this.leadTravelServices.includes('Sightseeing') ? true : false;
    //   this.serviceBasedSections.showTransportation = this.leadTravelServices.includes("Transportations") ? true : false;
    //   this.serviceBasedSections.showTransfers = this.leadTravelServices.includes("Transfers") ? true : false;
    //   this.serviceBasedSections.showTourPackage = this.leadTravelServices.includes("Tour Package") ? true : false;

    //   this.updateListOfTabsForQuote(this.serviceBasedSections);
    //   this.reloadAllChildComponents();
    // })
  }

  updateListOfTabsForQuote(visibleTabs: any) {
    this.orderOfTabs = ['lead', 'details', 'route', 'accommodation', 'transportation', 'cost', 'inclusion', 'combined-terms', 'important', 'notes', 'templates', 'templates-details', 'review']
    if (!visibleTabs.showHotels) {
      let index = this.orderOfTabs.indexOf("accommodation");
      if (index > -1) {
        this.orderOfTabs.splice(index, 1);
      }
    }

    if (!visibleTabs.showTransportation && !visibleTabs.showTransfers) {
      let index = this.orderOfTabs.indexOf("transportation");
      if (index > -1) {
        this.orderOfTabs.splice(index, 1);
      }
    }

    if (!visibleTabs.showRouteCraft) {
      let index = this.orderOfTabs.indexOf("route");
      if (index > -1) {
        this.orderOfTabs.splice(index, 1);
      }
    }
  }

  updateListOfTabsForInventory() {
    this.orderOfTabs = ['details', 'route', 'inclusion', 'combined-terms', 'important', 'notes'];
    this.orderOfTabsIndex = 0;
    this.componentView = this.orderOfTabs[this.orderOfTabsIndex];
  }

  updateListOfTabsForDmcPackage() {
    this.orderOfTabs = ['lead', 'details', 'dmcPackage', 'transportation', 'cost', 'inclusion', 'combined-terms', 'important', 'notes', 'templates', 'templates-details', 'review'];
  }

  deleteAuditData(object: any) {
    let newObject = { ...object };
    delete newObject.category;
    delete newObject.createDate;
    delete newObject.createdBy;
    delete newObject.id;
    delete newObject.isDeleted;
    delete newObject.itineraryId;
    delete newObject.packageId;
    delete newObject.modifiedBy;
    delete newObject.modifiedDate;
    delete newObject.section;
    delete newObject.parentItineraryId;
    delete newObject.status;
    delete newObject.organizationId;
    delete newObject.ownership;
    delete newObject.ownershipRole;
    delete newObject.organizationId;

    return newObject;
  }

  async closeModal(submitted: boolean = false) {
    if (this.checkCurrentFormDirty(this.componentView) || !this.isQuoteDataValid()) {
      if (await this._globalService.confirmActionPopup("Changes will not be saved, confirm to close", "Quote is invalid", "Confirm")) {
        this.navigateBack();
      }
    } else {
      this.navigateBack();
    }
  }

  navigateBack() {
    this._globalService.navigatePrev();
  }

  async onViewChange(goPrevious: boolean) {
    if (goPrevious) {
      this.orderOfTabsIndex--;
      this.componentView = this.orderOfTabs[this.orderOfTabsIndex];
    } else {
      this.orderOfTabsIndex++;
      await this.changeComponentView(this.orderOfTabs[this.orderOfTabsIndex]);
    }
  }

  // Fucntion to change view from clicking on tab buttons
  async onViewChangeFromTab(view: string) {
    // check if current tab is modified
    if (this.checkCurrentFormDirty(this.componentView)) {
      let res = await this._globalService.confirmTabChangeAction("You have unsaved data, do you want to Proceed?", "Unsaved Data / Invalid Form", "Save & Proceed", "Proceed")
      switch (res) {
        case 'saveProceed': {
          if (await this.saveDataOfCurrentForm(this.componentView)) {
            this.changeComponentView(view);
          }
          break
        }
        case 'proceed': {
          this.changeComponentView(view);
          break;
        }
      }
    } else {
      this.changeComponentView(view);
    }
  }

  async changeComponentView(view: any) {
    this.componentView = view;
    this.orderOfTabsIndex = this.orderOfTabs.indexOf(view);
    if (view === 'transportation' && this.destinationsReordered) {
    this.destinationsReordered = false;
    sessionStorage.removeItem('destinationsReordered');
    let flag = await this._globalService.confirmActionPopup(
      "Destinations have been reordered. do you wish to clear  Transporation details?.",
      "Destinations/Nights Changed",
      "Clear Data"
    );
    if (flag) {
      this.flightsTransportationFormData = null;
      this.trainTransportationFormData = null;
      this.busTransportationFormData = null;
      this.carTransportationFormData = null;
      this.ferryTransportationFormData = null;
      this.cruiseTransportationFormData = null;
      setTimeout(() => {
      if (this.transportationComponent) {
        this.transportationComponent.ngOnInit();
      }
    }, 100);
    }
  }
  }

  assignItineraryId(id: string) {
    this.itineraryId = id;
    const defaultValues = this._itineraryHelperService.getItineraryFormDefaultValues();
    
    if (this.leadId) {
      this.getTemplateDetails(this.itineraryId)
      defaultValues.editQuoteItinerary = id;
    }else{
      defaultValues.editInventoryItineraray = id;
    }

    this._itineraryHelperService.setItineraryFormDefaultValues(defaultValues);
  }

  async saveDataOfCurrentForm(view: any) {
    switch (view) {
      case 'lead': {
        return this.leadInformationComponent.onSubmit();
      }
      case 'details': {
        return this.itineraryDetailsComponent.onSubmit();
      }
      case 'accommodation': {
        return this.accomodationComponent.onSubmit();
      };
      case 'transportation': {
        return this.transportationComponent.onSubmit();
      };
      case 'route': {
        return this.routeCraftComponent.onSubmit();
      };
      case 'cost': {
        return this.costAndPriceComponent.onSubmit();
      };
      case 'dmcPackage': {
        return this.dmcPackageComponent.onSubmit();
      };
      case 'combined-terms': {
        return this.combinedTermsComponent.onSubmit();
      };
      case 'inclusion': {
        return this.inclusionsAndExclusionsComponent.onSubmit();
      }
      case 'terms': {
        return this.termsAndConditionsComponent.onSubmit();
      }
      case 'paymentTerms': {
        return this.paymentTermsAndConditionsComponent.onSubmit();
      }
      case 'cancellation': {
        return this.cancellationPolicyComponent.onSubmit();
      }
      case 'important': {
        return this.importantInformationComponent.onSubmit();
      }
      case 'notes': {
        return this.notesComponent.onSubmit();
      }
      case 'templates-details': {
        return this.templateDetailsComponent.onSubmit();
      }
      default: {
        return;
      }

    }
  }

  impactDaysChange() {
    if (this.routeCraftFormData) {
      this.routeCraftFormData.dataInvalid = true;
    }
    if (this.accommodationFormData) {
      this.accommodationFormData.dataInvalid = true;
    }
    if (this.flightsTransportationFormData) {
      this.flightsTransportationFormData.dataInvalid = true;
    }
    if (this.trainTransportationFormData) {
      this.trainTransportationFormData.dataInvalid = true;
    }
    if (this.busTransportationFormData) {
      this.busTransportationFormData.dataInvalid = true;
    }
    if (this.carTransportationFormData) {
      this.carTransportationFormData.dataInvalid = true;
    }
    if (this.ferryTransportationFormData) {
      this.ferryTransportationFormData.dataInvalid = true;
    }
    if (this.cruiseTransportationFormData) {
      this.cruiseTransportationFormData.dataInvalid = true;
    }
    if (this.costAndPricingFormData) {
      this.costAndPricingFormData.dataInvalid = true;
    }
  }

  impactGuestsChange() {
    if (this.accommodationFormData) {
      this.accommodationFormData.dataInvalid = true;
    }
    if (this.flightsTransportationFormData) {
      this.flightsTransportationFormData.dataInvalid = true;
    }
    if (this.trainTransportationFormData) {
      this.trainTransportationFormData.dataInvalid = true;
    }
    if (this.busTransportationFormData) {
      this.busTransportationFormData.dataInvalid = true;
    }
    if (this.carTransportationFormData) {
      this.carTransportationFormData.dataInvalid = true;
    }
    if (this.ferryTransportationFormData) {
      this.ferryTransportationFormData.dataInvalid = true;
    }
    if (this.cruiseTransportationFormData) {
      this.cruiseTransportationFormData.dataInvalid = true;
    }
    if (this.costAndPricingFormData) {
      this.costAndPricingFormData.dataInvalid = true;
    }
  }

  async impactDestinationChanges() {
    if (this.accommodationFormData) {
      this.accommodationFormData.dataInvalid = true;
      this.updateHotelForDestinations();
    }
    // Clearing route craft data as destination changed
    if(this.routeCraftFormData && this.serviceBasedSections.showRouteCraft){
      let flag = await this._globalService.confirmActionPopup("Destination has been changed, do you wish to clear Route & Craft data?", "Destinations/Nights Changed", "Clear Data");
      if(flag){
        this.routeCraftFormData.data = [];
        this.routeCraftComponent.ngOnInit();
      }
    }
    // Set flag for transportation warning to show when user navigates to transportation tab
    const hasTransportationData = this.flightsTransportationFormData ||
      this.trainTransportationFormData ||
      this.busTransportationFormData ||
      this.carTransportationFormData ||
      this.ferryTransportationFormData ||
      this.cruiseTransportationFormData;

    if (hasTransportationData) {
      this.destinationsReordered = true;
      sessionStorage.setItem('destinationsReordered', 'true');
    }
  }

  tourPackageRemovedImpact() {
    if (this.accommodationFormData) {
      this.accommodationFormData.dataInvalid = true;
    }
    if (this.flightsTransportationFormData) {
      this.flightsTransportationFormData.dataInvalid = true;
    }
    if (this.trainTransportationFormData) {
      this.trainTransportationFormData.dataInvalid = true;
    }
    if (this.busTransportationFormData) {
      this.busTransportationFormData.dataInvalid = true;
    }
    if (this.carTransportationFormData) {
      this.carTransportationFormData.dataInvalid = true;
    }
    if (this.ferryTransportationFormData) {
      this.ferryTransportationFormData.dataInvalid = true;
    }
    if (this.cruiseTransportationFormData) {
      this.cruiseTransportationFormData.dataInvalid = true;
    }
    if (this.costAndPricingFormData) {
      this.costAndPricingFormData.dataInvalid = true;
    }
  }

  checkCurrentFormDirty(view: any): any {
    switch (view) {
      case 'lead': {
        return (this.leadInformationComponent?.formDataModified());
      }
      case 'details': {
        return (this.itineraryDetailsComponent?.formDataModified());
      }
      case 'accommodation': {
        return (this.accomodationComponent?.formDataModified());
      };
      case 'transportation': {
        return (this.transportationComponent?.formDataModified());
      };
      case 'route': {
        return (this.routeCraftComponent?.formDataModified());
      };
      case 'cost': {
        return (this.costAndPriceComponent?.formDataModified());
      };
      case 'dmcPackage': {
        return (this.dmcPackageComponent?.formDataModified());
      };
      case 'combined-terms': {
        return (this.combinedTermsComponent?.formDataModified())
      };
      case 'inclusion': {
        return (this.inclusionsAndExclusionsComponent?.formDataModified());
      }
      case 'terms': {
        return (this.termsAndConditionsComponent?.formDataModified());
      }
      case 'paymentTerms': {
        return (this.paymentTermsAndConditionsComponent?.formDataModified());
      }
      case 'cancellation': {
        return (this.cancellationPolicyComponent?.formDataModified());
      }
      case 'important': {
        return (this.importantInformationComponent?.formDataModified());
      }
      case 'notes': {
        return (this.notesComponent?.formDataModified());
      }
      case 'templates-details': {
        return (this.templateDetailsComponent?.formDataModified())
      }
      default: {
        return false;
      }
    }
  }

  // Storing tab data here when add API of that respective tab is called

  storeDetailsData(formData: any) {
    this.detailsFormData = formData
  }
  storeAccommodationData(formData: any) {
    this.accommodationFormData = formData
  }
  // storeTransporationData(formData: any) {
  //   this.transportationFormData = formData
  // }
  storeFlightsData(formData: any) {
    this.flightsTransportationFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    }
  }
  storeEditedFlightsData(formData: any) {
    this.flightsEditedFormData = formData;
  }
  storeTrainsData(formData: any) {
    this.trainTransportationFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    }
  }
  storeBusesData(formData: any) {
    this.busTransportationFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    };
  }
  storeCarsData(formData: any) {
    this.carTransportationFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    };
  }
  storeFerryData(formData: any) {
    this.ferryTransportationFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    };
  }
  storeCruiseData(formData: any) {
    this.cruiseTransportationFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    };
  }
  storeRouteCraftData(formData: any) {
    this.routeCraftFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    };
  }
  storeInclusionsAndExclusionData(formData: any) {
    this.inclusionsAndExclusionsFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    }
  }

  storeDmcHotelPricingData(formData: any) {
    this.dmcHotelPricingFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    };
  }
  storeCostAndPricingData(formData: any) {
    this.costAndPricingFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    }
  }
  storeTermsAndConditionsData(formData: any) {
    this.termsAndConditionsFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    }
  }
  storePaymentTermsAndConditionsData(formData: any) {
    this.paymentTermsAndConditionsFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    }
  }
  storeCancellationPolicyData(formData: any) {
    this.cancellationPolicyFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    }
  }
  storeImportantInformationData(formData: any) {
    this.importantInformationFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    }
  }
  storeNotesData(formData: any) {
    this.notesFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    }
  }
  storeTemplatesData(formData: any) {
    this.templatesFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    }
  }
  storeTemplateDetailsData(formData: any) {
    this.templatesDetailsFormData = {
      ...formData,
      dataSaved: true,
      dataInvalid: false
    }
  }

  async openReviewScreen() {
    if (this.checkCurrentFormDirty(this.componentView)) {
      let res = await this._globalService.confirmTabChangeAction("You have unsaved data, do you want to Proceed?", "Unsaved Data / Invalid Form", "Save & Proceed", "Proceed")
      switch (res) {
        case 'saveProceed': {
          if (await this.saveDataOfCurrentForm(this.componentView)) {
            this.openQuoteReview();
          }
          break
        }
        case 'proceed': {
          this.openQuoteReview();
          break;
        }
      }
    } else {
      this.openQuoteReview();
    }
  }

  async openQuoteReview() {
    if (this.isQuoteDataValid()) {
      await this._modalPopupService.closeAllModals();
      if (this.leadId) {
        this.openReviewItineraryView(this.itineraryId, this.leadId, this.detailsFormData.clientId);
      } else {
        this._modalPopupService.openInventoryItineraryView(this.itineraryId, null, null);
      }
    } else {
      this._globalService.customAlert("Validate all sections", "Quote is invalid");
    }

  }

  async openReviewItineraryView(quoteId: any, leadId: any, clientId: any) {
    const modal = await this._modalController.create({
      component: ReviewItineraryComponent,
      cssClass: 'view-a4-side-modal',
      componentProps: {
        quoteId: quoteId,
        leadId: leadId,
        clientId: clientId
      }
    });

    await modal.present();
  }

  getTemplateDetails(quoteId: any) {
    this._itineraryService.getQuoteData(quoteId).subscribe((data) => {
      this.templatesDetailsFormData = data.template;
      this.templatesDetailsFormData.dataSaved = true;

      this.templatesFormData = data.template;
      this.templatesFormData.dataSaved = true;
    })
  }

  handleFlightsRemoved(){
    if(this.costAndPricingFormData){
      this.costAndPricingFormData.airfarePerAdult = 0;
      this.costAndPricingFormData.airfarePerChild = 0;
      this.costAndPricingFormData.airfarePerInfant = 0;
      this.costAndPricingFormData.totalAirfare = 0;

      if(this.costAndPricingFormData.landPackages && this.costAndPricingFormData.landPackages?.length){
        for(let i = 0; i < this.costAndPricingFormData.landPackages.length; i++){
          this.costAndPricingFormData.landPackages[i].packageIncludingAirfare = this.costAndPricingFormData.landPackages[i].packageCost;
        }
      }
    }
  }

  // Function to update quite and flight details
  async updateQuote() {
    this.serializeQuoteFormData().then(formData => {
      const apiItineraryId = this.parentItineraryId ? this.parentItineraryId : this.editQuoteItinerary;
      this._itineraryService.updateQuote(apiItineraryId, formData).subscribe(async (data) => {
        this._responseNotificationService.showMessage("Quote Updated!");
        if (this.flightsEditedFormData) {
          await this.updateQuoteFlightData(this.flightsEditedFormData, data.itineraryDetails.itineraryId);
        }

        // Assigning new responce data to global variable
        this.editQuoteItinerary = data.itineraryDetails.itineraryId;
        this.itineraryId = data.itineraryDetails.itineraryId;
        this.quoteItineraryData = data;
        this.assignItineraryQuoteDetails();
        this.reloadAllChildComponents();
        this._reloadService.triggerQuotesReload();
      });
    });
  }

  async updateQuoteFlightData(formData: FormData, quoteId: string): Promise<boolean> {
    try {
      // Update formData with the provided quoteId
      formData.delete('itineraryId');
      formData.append('itineraryId', quoteId);

      // Await the API call
      const data = await this._itineraryService.addTransportationFlights(formData).toPromise();
      data.dataSaved = true;
      this.flightsTransportationFormData = data;
      this.reloadAllChildComponents();

      // Resetting Flights Form Data
      this.flightsEditedFormData = undefined;
      return true; // Indicate success
    } catch (error) {
      console.error("Error updating flight details:", error);
      return false; // Indicate failure
    }
  }

  updateHotelsInCostAndPricing(hotelsData: any[]): void {
  if (!this.costAndPricingFormData?.landPackages) {
    console.error("Invalid costAndPricingFormData or packages are missing.");
    return;
  }

  // STEP 1 - Build a lookup map from hotelsData
  const hotelLookup = new Map<string, any>();

  for (const dest of hotelsData) {
    for (const loc of dest.locations || []) {
      for (const hotel of loc.hotels || []) {
        const key = `${dest.destination}|${loc.locationName}|${hotel.hotelName}`;
        hotelLookup.set(key, hotel);
      }
    }
  }

  // STEP 2 - Loop over all land packages
  for (const packageItem of this.costAndPricingFormData.landPackages) {
    if (!Array.isArray(packageItem.hotelsIncluded)) continue;

    const updatedDestinations = [];

    for (const dest of packageItem.hotelsIncluded) {
      const updatedLocations = [];

      for (const loc of dest.locations || []) {
        const updatedHotels = [];

        for (const hotel of loc.hotels || []) {
          const lookupKey = `${dest.destination}|${loc.locationName}|${hotel.hotelName}`;
          const matchingHotel = hotelLookup.get(lookupKey);

          if (matchingHotel) {
            // Hotel exists → update hotel data
            Object.assign(hotel, matchingHotel);
            updatedHotels.push(hotel);
          }
          // else skip this hotel (removes it)
        }

        if (updatedHotels.length > 0) {
          // keep this location only if it has hotels
          updatedLocations.push({
            ...loc,
            hotels: updatedHotels
          });
        }
      }

      if (updatedLocations.length > 0) {
        // keep this destination only if it has locations
        updatedDestinations.push({
          ...dest,
          locations: updatedLocations
        });
      }
    }

    // Overwrite hotelsIncluded with updated data
    packageItem.hotelsIncluded = updatedDestinations;
  }
}


  updateHotelForDestinations() {
    // TODO: correct logic to remote hotels based on destination and uncomment

    if (!this.accommodationFormData || !Array.isArray(this.accommodationFormData.data) || !this.detailsFormData || !Array.isArray(this.detailsFormData.destination)) {
      return;
    }
    // Normalize destination locations for comparison
    const destinationLocations = this.detailsFormData.destination
      .filter((dest: any) => dest && dest.location)
      .map((dest: any) => dest.location && typeof dest.location === 'string' ? dest.location.trim().toLowerCase() : dest.location);

    this.accommodationFormData.data = this.accommodationFormData.data.map((dest:any) => {
        const filteredLocations = (dest.locations || []).filter((loc:any) => {
          return destinationLocations.includes(
            loc.locationName?.toString().trim().toLowerCase()
          );
        });

        return {
          ...dest,
          locations: filteredLocations
        };
      })
      // remove destinations that have no remaining locations
      .filter((dest:any) => (dest.locations || []).length > 0);
  }


  // Function to update inventory Itineray

  updateInventoryItinerary() {
    this.serializeInventoryFormData().then(formData => {
      this._inventoryService.updateInventoryItinerary(this.itineraryId, formData).subscribe((data) => {
        if (data) {
          this._reloadService.triggerInventoryItineraryReload()
          this._responseNotificationService.showMessage("Inventory Itinerary Updated!");

          this.editInventoryItineraray = data.itineraryDetails.itineraryId;
          this.itineraryId = data.itineraryDetails.itineraryId;
          this.inventoryItineraryData = data;
          this.assignInventoryItineraryDetails();
          this.reloadAllChildComponents();
        }
      })
    });
  }

  async quoteCurrencyChanged(event : any){
    const selectedCurrency = event;
    this.detailsFormData.currencyCode = selectedCurrency;    
    const data = await this._itineraryService.addItineraryDetails(this.detailsFormData).toPromise();
    this.detailsFormData = {
      ...data,
      dataSaved: true,
      dataInvalid: false
    }
  }

  isQuoteDataValid(): boolean {
    // List of all form data objects
    const formDataList = [
      this.detailsFormData,
      this.costAndPricingFormData
    ];

    if (this.serviceBasedSections.showHotels) {
      formDataList.push(this.accommodationFormData);
    }

    if (this.serviceBasedSections.showTransportation) {
      formDataList.push(this.flightsTransportationFormData)
      formDataList.push(this.trainTransportationFormData);
      formDataList.push(this.busTransportationFormData);
      formDataList.push(this.ferryTransportationFormData);
      formDataList.push(this.cruiseTransportationFormData);
    }

    if (this.serviceBasedSections.showRouteCraft) {
      formDataList.push(this.routeCraftFormData);
      // formDataList.push(this.costAndPricingFormData);
    }
    if (this.serviceBasedSections.showTransfers) {
      formDataList.push(this.carTransportationFormData);
    }

    // Loop through all form data objects
    for (let formData of formDataList) {
      // Check if 'dataInvalid' is true in any form data object
      if (formData?.dataInvalid === true) {
        return false; // If found, return false immediately
      }
    }

    // If none of the objects have 'dataInvalid' as true, return true
    return true;
  }


  private async serializeInventoryFormData() {
    const serializedData = {
      itineraryDetails: {
        ...this.detailsFormData,
        modifiedBy: this.inventoryItineraryData.itineraryDetails ? this.inventoryItineraryData.itineraryDetails.modifiedBy : null,
        modifiedDate: this.inventoryItineraryData.itineraryDetails ? this.inventoryItineraryData.itineraryDetails.modifiedDate : null,
        section: this.inventoryItineraryData.itineraryDetails ? this.inventoryItineraryData.itineraryDetails.section : null,
        isDeleted: this.inventoryItineraryData.itineraryDetails ? this.inventoryItineraryData.itineraryDetails.isDeleted : null,
        category: this.inventoryItineraryData.itineraryDetails ? this.inventoryItineraryData.itineraryDetails.category : null,
      },
      routeCrafts: this.routeCraftFormData ? {
        ...this.routeCraftFormData,
        ...(this.routeCraftFormData.createDate && { createDate: this.routeCraftFormData.createDate }),
        modifiedBy: this.inventoryItineraryData.routeCrafts ? this.inventoryItineraryData.routeCrafts.modifiedBy : null,
        ...(this.inventoryItineraryData.routeCrafts && { modifiedDate: this.inventoryItineraryData.routeCrafts.modifiedDate }),
        section: this.inventoryItineraryData.routeCrafts ? this.inventoryItineraryData.routeCrafts.section : null,
        status: this.inventoryItineraryData.routeCrafts ? this.inventoryItineraryData.routeCrafts.status : null,
        ...(this.inventoryItineraryData.routeCrafts && { isDeleted: this.inventoryItineraryData.routeCrafts.isDeleted }),
        category: this.inventoryItineraryData.routeCrafts ? this.inventoryItineraryData.routeCrafts.category : null,
      } : null,
      inclusionAndExclusions: this.inclusionsAndExclusionsFormData ? {
        ...this.inclusionsAndExclusionsFormData,
        ...(this.inclusionsAndExclusionsFormData.createDate && { createDate: this.inclusionsAndExclusionsFormData.createDate }),
        modifiedBy: this.inventoryItineraryData.inclusionAndExclusions ? this.inventoryItineraryData.inclusionAndExclusions.modifiedBy : null,
        ...(this.inventoryItineraryData.inclusionAndExclusions && { modifiedDate: this.inventoryItineraryData.inclusionAndExclusions.modifiedDate }),
        section: this.inventoryItineraryData.inclusionAndExclusions ? this.inventoryItineraryData.inclusionAndExclusions.section : null,
        status: this.inventoryItineraryData.inclusionAndExclusions ? this.inventoryItineraryData.inclusionAndExclusions.status : null,
        category: this.inventoryItineraryData.inclusionAndExclusions ? this.inventoryItineraryData.inclusionAndExclusions.category : null,
      } : null,
      termsAndConditions: this.termsAndConditionsFormData ? {
        ...this.termsAndConditionsFormData,
        ...(this.termsAndConditionsFormData.createDate && { createDate: this.termsAndConditionsFormData.createDate }),
        modifiedBy: this.inventoryItineraryData.termsAndConditions ? this.inventoryItineraryData.termsAndConditions.modifiedBy : null,
        ...(this.inventoryItineraryData.termsAndConditions && { modifiedDate: this.inventoryItineraryData.termsAndConditions.modifiedDate }),
        section: this.inventoryItineraryData.termsAndConditions ? this.inventoryItineraryData.termsAndConditions.section : null,
        status: this.inventoryItineraryData.termsAndConditions ? this.inventoryItineraryData.termsAndConditions.status : null,
        category: this.inventoryItineraryData.termsAndConditions ? this.inventoryItineraryData.termsAndConditions.category : null,
      } : null,
      cancellationPolicies: this.cancellationPolicyFormData ? {
        ...this.cancellationPolicyFormData,
        ...(this.cancellationPolicyFormData.createDate && { createDate: this.cancellationPolicyFormData.createDate }),
        modifiedBy: this.inventoryItineraryData.cancellationPolicies ? this.inventoryItineraryData.cancellationPolicies.modifiedBy : null,
        ...(this.inventoryItineraryData.cancellationPolicies && { modifiedDate: this.inventoryItineraryData.cancellationPolicies.modifiedDate }),
        section: this.inventoryItineraryData.cancellationPolicies ? this.inventoryItineraryData.cancellationPolicies.section : null,
        status: this.inventoryItineraryData.cancellationPolicies ? this.inventoryItineraryData.cancellationPolicies.status : null,
        category: this.inventoryItineraryData.cancellationPolicies ? this.inventoryItineraryData.cancellationPolicies.category : null,
      } : null,
      importantInformations: this.importantInformationFormData ? {
        ...this.importantInformationFormData,
        ...(this.importantInformationFormData.createDate && { createDate: this.importantInformationFormData.createDate }),
        modifiedBy: this.inventoryItineraryData.importantInformations ? this.inventoryItineraryData.importantInformations.modifiedBy : null,
        ...(this.inventoryItineraryData.importantInformations && { modifiedDate: this.inventoryItineraryData.importantInformations.modifiedDate }),
        section: this.inventoryItineraryData.importantInformations ? this.inventoryItineraryData.importantInformations.section : null,
        status: this.inventoryItineraryData.importantInformations ? this.inventoryItineraryData.importantInformations.status : null,
        category: this.inventoryItineraryData.importantInformations ? this.inventoryItineraryData.importantInformations.category : null,
      } : null,
      notes: this.notesFormData ? {
        ...this.notesFormData,
        ...(this.notesFormData.createDate && { createDate: this.notesFormData.createDate }),
        modifiedBy: this.inventoryItineraryData.notes ? this.inventoryItineraryData.notes.modifiedBy : null,
        ...(this.inventoryItineraryData.notes && { modifiedDate: this.inventoryItineraryData.notes.modifiedDate }),
        section: this.inventoryItineraryData.notes ? this.inventoryItineraryData.notes.section : null,
        status: this.inventoryItineraryData.notes ? this.inventoryItineraryData.notes.status : null,
        category: this.inventoryItineraryData.notes ? this.inventoryItineraryData.notes.category : null,
      } : null

    }
    return serializedData;
  }

  // Function to serialize the quote modal
  private async serializeQuoteFormData() {
    const serializedData = {
      itineraryDetails: {
        ...this.detailsFormData,
        parentItineraryId: this.parentItineraryId,
        section: this.quoteItineraryData?.itineraryDetails ? this.quoteItineraryData.itineraryDetails.section : null,
        category: this.quoteItineraryData?.itineraryDetails ? this.quoteItineraryData.itineraryDetails.category : null,
      },
      accommodations: this.accommodationFormData ? {
        ...this.accommodationFormData,
        parentItineraryId: this.parentItineraryId,
        category: this.quoteItineraryData?.accommodations ? this.quoteItineraryData.accommodations.category : null,
        section: this.quoteItineraryData?.accommodations ? this.quoteItineraryData.accommodations.section : null
      } : null,
      flights: this.flightsTransportationFormData ? {
        ...this.flightsTransportationFormData,
        parentItineraryId: this.parentItineraryId,
        category: this.quoteItineraryData?.flights ? this.quoteItineraryData.flights.category : null,
        ...(this.quoteItineraryData?.flights && { createDate: this.quoteItineraryData.flights.createDate }),
        createdBy: this.quoteItineraryData?.flights ? this.quoteItineraryData.flights.createdBy : null,
        section: this.quoteItineraryData?.flights ? this.quoteItineraryData.flights.section : null
      } : null,

      trains: this.trainTransportationFormData ? {
        ...this.trainTransportationFormData,
        parentItineraryId: this.parentItineraryId,
        category: this.quoteItineraryData?.trains ? this.quoteItineraryData.trains.category : null,
        ...(this.quoteItineraryData?.trains && { createDate: this.quoteItineraryData.trains.createDate }),
        createdBy: this.quoteItineraryData?.trains ? this.quoteItineraryData.trains.createdBy : null,
        section: this.quoteItineraryData?.trains ? this.quoteItineraryData.trains.section : null
      } : null,
      buses: this.busTransportationFormData ? {
        ...this.busTransportationFormData,
        parentItineraryId: this.parentItineraryId,
        category: this.quoteItineraryData?.buses ? this.quoteItineraryData.buses.category : null,
        ...(this.quoteItineraryData?.buses && { createDate: this.quoteItineraryData.buses.createDate }),
        createdBy: this.quoteItineraryData?.buses ? this.quoteItineraryData.buses.createdBy : null,
        section: this.quoteItineraryData?.buses ? this.quoteItineraryData.buses.section : null
      } : null,
      cars: this.carTransportationFormData ? {
        ...this.carTransportationFormData,
        parentItineraryId: this.parentItineraryId,
        category: this.quoteItineraryData?.cars ? this.quoteItineraryData.cars.category : null,
        ...(this.quoteItineraryData?.cars && { createDate: this.quoteItineraryData.cars.createDate }),
        createdBy: this.quoteItineraryData?.cars ? this.quoteItineraryData.cars.createdBy : null,
        section: this.quoteItineraryData?.cars ? this.quoteItineraryData.cars.section : null
      } : null,
      ferries: this.ferryTransportationFormData ? {
        ...this.ferryTransportationFormData,
        parentItineraryId: this.parentItineraryId,
        category: this.quoteItineraryData?.ferries ? this.quoteItineraryData.ferries.category : null,
        ...(this.quoteItineraryData?.ferries && { createDate: this.quoteItineraryData.ferries.createDate }),
        createdBy: this.quoteItineraryData?.ferries ? this.quoteItineraryData.ferries.createdBy : null,
        section: this.quoteItineraryData?.ferries ? this.quoteItineraryData.ferries.section : null
      } : null,
      cruises: this.cruiseTransportationFormData ? {
        ...this.cruiseTransportationFormData,
        parentItineraryId: this.parentItineraryId,
        category: this.quoteItineraryData?.cruises ? this.quoteItineraryData.cruises.category : null,
        ...(this.quoteItineraryData?.cruises && { createDate: this.quoteItineraryData.cruises.createDate }),
        createdBy: this.quoteItineraryData?.cruises ? this.quoteItineraryData.cruises.createdBy : null,
        section: this.quoteItineraryData?.cruises ? this.quoteItineraryData.cruises.section : null
      } : null,
      costAndPricings: this.costAndPricingFormData ? {
        ...this.costAndPricingFormData,
        parentItineraryId: this.parentItineraryId,
        category: this.quoteItineraryData?.costAndPricings ? this.quoteItineraryData.costAndPricings.category : null,
        section: this.quoteItineraryData?.costAndPricings ? this.quoteItineraryData.costAndPricings.section : null
      } : null,
      hotelPricingCollection: this.dmcHotelPricingFormData ? {
        ...this.dmcHotelPricingFormData,
        parentItineraryId: this.parentItineraryId,
        category: this.quoteItineraryData?.hotelPricingCollection ? this.quoteItineraryData.hotelPricingCollection.category : null,
        section: this.quoteItineraryData?.hotelPricingCollection ? this.quoteItineraryData.hotelPricingCollection.section : null
      } : null,
      routeCrafts: this.routeCraftFormData ? {
        ...this.routeCraftFormData,
        parentItineraryId: this.parentItineraryId,
        section: this.quoteItineraryData?.routeCrafts ? this.quoteItineraryData.routeCrafts.section : null,
        category: this.quoteItineraryData?.routeCrafts ? this.quoteItineraryData.routeCrafts.category : null,
      } : null,
      inclusionAndExclusions: this.inclusionsAndExclusionsFormData ? {
        ...this.inclusionsAndExclusionsFormData,
        section: this.quoteItineraryData?.inclusionAndExclusions ? this.quoteItineraryData.inclusionAndExclusions.section : null,
        category: this.quoteItineraryData?.inclusionAndExclusions ? this.quoteItineraryData.inclusionAndExclusions.category : null,
      } : null,
      termsAndConditions: this.termsAndConditionsFormData ? {
        ...this.termsAndConditionsFormData,
        section: this.quoteItineraryData?.termsAndConditions ? this.quoteItineraryData.termsAndConditions.section : null,
        category: this.quoteItineraryData?.termsAndConditions ? this.quoteItineraryData.termsAndConditions.category : null,
      } : null,
      paymentTermsAndConditions: this.paymentTermsAndConditionsFormData ? {
        ...this.paymentTermsAndConditionsFormData,
        section: this.quoteItineraryData?.paymentTermsAndConditions ? this.quoteItineraryData.paymentTermsAndConditions.section : null,
        category: this.quoteItineraryData?.paymentTermsAndConditions ? this.quoteItineraryData.paymentTermsAndConditions.category : null,
      } : null,
      cancellationPolicies: this.cancellationPolicyFormData ? {
        ...this.cancellationPolicyFormData,
        section: this.quoteItineraryData?.cancellationPolicies ? this.quoteItineraryData.cancellationPolicies.section : null,
        category: this.quoteItineraryData?.cancellationPolicies ? this.quoteItineraryData.cancellationPolicies.category : null,
      } : null,
      importantInformations: this.importantInformationFormData ? {
        ...this.importantInformationFormData,
        section: this.quoteItineraryData?.importantInformations ? this.quoteItineraryData.importantInformations.section : null,
        category: this.quoteItineraryData?.importantInformations ? this.quoteItineraryData.importantInformations.category : null,
      } : null,
      notes: this.notesFormData ? {
        ...this.notesFormData,
        section: this.quoteItineraryData?.notes ? this.quoteItineraryData.notes.section : null,
        category: this.quoteItineraryData?.notes ? this.quoteItineraryData.notes.category : null,
      } : null
    }

    return serializedData;
  }

  async submitQuote() {
    console.log(1);
    
    if (await this._globalService.confirmActionPopup("Submitting a quote will start creating versions when updated.", "Confirm To Submit")) {
      this.makeQuoteActive();
    }
  }

  makeQuoteActive() {
    this._itineraryService.getQuoteData(this.itineraryId).subscribe(async (data) => {
      let keys = Object.keys(data);
      let leadId = data.itineraryDetails.leadId;

      try {
        // Wait for lead travel services to be fetched
        let leadTravelServices = this.serviceBasedSections;

        if (!leadTravelServices.showHotels) {
          keys = keys.filter(item => item !== "accommodations");
        }
        if (!leadTravelServices.showRouteCraft) {
          keys = keys.filter(item => item !== "routeCrafts");
          keys = keys.filter(item => item !== "costAndPricings");
        }
        keys = keys.filter(item => !["flights", "cars", "trains", "buses", "ferries", "cruises", "notes", "paymentTermsAndConditions", "hotelPricingCollection"].includes(item));


        // Check if any data keys are null
        for (let key of keys) {
          if (data[key] === null) {
            await this._globalService.customAlert("Fill all quote details to submit");
            return;
          }
        }

        // Update status after validation
        this._statusUpdateService.updateStatusOfRecord(ENTITY_NAMES.QUOTE, this.itineraryId, RECORD_STATUS_VALUES.ACTIVE).subscribe(async (data) => {
          if (data) {
            this._responseNotificationService.showMessage("Quote Is Active!");

            await this.saveAsInventoryItinerary(this.itineraryId);

            await this._modalPopupService.closeAllModals();
            this._modalPopupService.openReviewItineraryView(this.itineraryId, leadId, this.detailsFormData.clientId);
          }
          this._reloadService.triggerQuotesReload();
        });

      } catch (error) {
        console.error('Error fetching lead travel services:', error);
      }
    });
  }

  async saveAsInventoryItinerary(quoteId: any) {
    if (await this._globalService.confirmActionPopup("Do you want to save this quote in Inventory?", "Save in inventory", "Yes")) {
      this._itineraryService.saveAsInventoryItinerary(quoteId).subscribe((data) => {
        if (data) {
          this._responseNotificationService.showMessage("Quote saved as Inventory Itinerary!");
        }
      },
        (error) => {
          this._responseNotificationService.showMessage("Failed to save as Inventory Itinerary!", true);
        }
      )
    }
  }

  showSubmitButton(): boolean {
    if (this.componentView !== 'lead' && this.leadId && this.quoteStatus === RECORD_STATUS_VALUES.DRAFT) {
      const formDataList = [
        this.detailsFormData,
        this.costAndPricingFormData,
        this.inclusionsAndExclusionsFormData,
        this.termsAndConditionsFormData,
        this.paymentTermsAndConditionsFormData,
        this.cancellationPolicyFormData,
        this.importantInformationFormData
      ];

      if (this.serviceBasedSections.showHotels) {
        formDataList.push(this.accommodationFormData);
      }
      if (this.serviceBasedSections.showRouteCraft) {
        formDataList.push(this.routeCraftFormData);
      }

      for (let formData of formDataList) {
        if (!formData || formData?.dataInvalid === true) {
          return false;
        }
      }

      return true;
    } else {
      return false;
    }

  }
}

